class NumericInputOnly {
    constructor(selector) {
        this.inputs = document.querySelectorAll(selector);
        this.attachEventListeners();
    }

    attachEventListeners() {
        this.inputs.forEach((input) => {
            input.addEventListener('input', () => {
                this.validateInput(input);
            });
        });
    }

    validateInput(input) {
        input.value = input.value.replace(/\D/g, '');
    }
}

// Initialize the class by passing the class selector
const numericInputs = new NumericInputOnly('.numeric-input');